import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        // web-雅安职业技术学院
        {
            path:'/yazyjsxy',
            name:'web_yazyjsxy',
            component: () => import('./views/web/yazyjsxy.vue')
        },
        // web-重庆城市管理职业学院
        {
            path:'/cqcsglzyxy',
            name:'web_cqcsglzyxy',
            component: () => import('./views/web/cqcsglzyxy.vue')
        },
        // web-北京青年政治学院
        {
            path:'/bjqnzzxy',
            name:'web_bjqnzzxy',
            component: () => import('./views/web/bjqnzzxy.vue')
        },
        // web-广州番禺职业技术学院
        {
            path:'/gzpyzyjsxy',
            name:'web_gzpyzyjsxy',
            component: () => import('./views/web/gzpyzyjsxy.vue')
        },
        // web-湖北铁道运输职业学院
        {
            path:'/hbtdyszyxy',
            name:'web_hbtdyszyxy',
            component: () => import('./views/web/hbtdyszyxy.vue')
        },
        // web-成都汽车职校
        {
            path:'/cdqczx',
            name:'web_cdqczx',
            component: () => import('./views/web/cdqczx.vue')
        },
        // web-四川信息职业技术学院
        {
            path:'/scxxzyjsxy',
            name:'web_scxxzyjsxy',
            component: () => import('./views/web/scxxzyjsxy.vue')
        },
        // web-西南财经大学
        {
            path:'/xncjdx',
            name:'web_xncjdx',
            component: () => import('./views/web/xncjdx.vue')
        },
        // web-成都工业职业技术学院
        {
            path:'/cdgyzyjsxy',
            name:'web_cdgyzyjsxy',
            component: () => import('./views/web/cdgyzyjsxy.vue')
        },
        // web-新疆农业职业技术学院
        {
            path:'/xjnyzyjsxy',
            name:'web_xjnyzyjsxy',
            component: () => import('./views/web/xjnyzyjsxy.vue')
        },
        // web-成都航空职业技术学院
        {
            path:'/cdhkzyjsxy',
            name:'web_cdhkzyjsxy',
            component: () => import('./views/web/cdhkzyjsxy.vue')
        },
        // web-福建信息职业技术学院
        {
            path:'/fjxxzyjsxy',
            name:'web_fjxxzyjsxy',
            component: () => import('./views/web/fjxxzyjsxy.vue')
        },
        // web-云南国土资源职业学院
        {
            path:'/yngtzyzyxy',
            name:'web_yngtzyzyxy',
            component: () => import('./views/web/yngtzyzyxy.vue')
        },
        // web-重庆青年职业技术学院
        {
            path:'/cqqnzyjsxy',
            name:'web_cqqnzyjsxy',
            component: () => import('./views/web/cqqnzyjsxy.vue')
        },
        // web-重庆公共运输职业学院
        // {
        //     path:'/cqggyszyxy',
        //     name:'web_cqggyszyxy',
        //     component: () => import('./views/web/cqggyszyxy.vue')
        // },
        // web-广东科贸职业学院
        {
            path:'/gdkmzyxy_241128',
            name:'web_gdkmzyxy',
            component: () => import('./views/web/gdkmzyxy.vue')
        },
        // web-太原学院
        {
            path:'/tyxy',
            name:'web_tyxy',
            component: () => import('./views/web/tyxy.vue')
        },
        // web-天津铁道职业技术学院
        {
            path:'/tjtdzyjsxy',
            name:'web_tjtdzyjsxy',
            component: () => import('./views/web/tjtdzyjsxy.vue')
        },
        // web-演示学院
        {
            path:'/ysxy',
            name:'web_ysxy',
            component: () => import('./views/web/ysxy.vue')
        },
        // web-郑州铁路职业技术学院
        {
            path:'/zztlzyjsxy',
            name:'web_zztlzyjsxy',
            component: () => import('./views/web/zztlzyjsxy.vue')
        },
        // web-黑龙江农业职业技术学院
        {
            path:'/hljnyzyjsxy',
            name:'web_hljnyzyjsxy',
            component: () => import('./views/web/hljnyzyjsxy.vue')
        },
        // web-贵州机电职业技术学院
        {
            path:'/gzjdzyjsxy',
            name:'web_gzjdzyjsxy',
            component: () => import('./views/web/gzjdzyjsxy.vue')
        },
        // web-安徽电子信息职业技术学院
        {
            path:'/ahdzxxzyjsxy',
            name:'web_ahdzxxzyjsxy',
            component: () => import('./views/web/ahdzxxzyjsxy.vue')
        },
        // web-天津师范大学
        {
            path:'/tjsfdx',
            name:'web_tjsfdx',
            component: () => import('./views/web/tjsfdx.vue')
        },
        // web-成都工业学院
        {
            path:'/cdgyxy',
            name:'web_cdgyxy',
            component: () => import('./views/web/cdgyxy.vue')
        },
        // web-成都信息工程大学
        // {
        //     path:'/cdxxgcdx',
        //     name:'web_cdxxgcdx',
        //     component: () => import('./views/web/cdxxgcdx.vue')
        // },
        // web-济南职业学院
        {
            path:'/jnzyxy',
            name:'web_jnzyxy',
            component: () => import('./views/web/jnzyxy.vue')
        },
        // web-延安职院
        {
            path:'/yazy',
            name:'web_yazy',
            component: () => import('./views/web/yazy.vue')
        },
        // web-延安职院
        {
            path:'/cdkfdx',
            name:'web_cdkfdx',
            component: () => import('./views/web/cdkfdx.vue')
        },
        // web-天津电子信息职业技术学院
        {
            path:'/tjdzxxzyjsxy',
            name:'web_tjdzxxzyjsxy',
            component: () => import('./views/web/tjdzxxzyjsxy.vue')
        },
        // web-四川华新现代职业学院
        {
            path:'/schxxdzyxy',
            name:'web_schxxdzyxy',
            component: () => import('./views/web/schxxdzyxy.vue')
        },
    ]
})
